(function () {
  const DESKTOP_BREAKPOINT = 990;
  const HOVER_CLOSE_DELAY = 150;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function closeAllDetails(except) {
    document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => {
      if (d !== except) {
        d.removeAttribute('open');
        const summary = d.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initHoverMenu() {
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    inlineMenu.querySelectorAll('details').forEach((details) => {
      let closeTimer = null;

      details.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        closeAllDetails(details);
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, HOVER_CLOSE_DELAY);
      });

      const summary = details.querySelector('summary[data-url]');
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (!isDesktop()) return;
          if (details.hasAttribute('open')) {
            e.preventDefault();
            window.location.href = summary.dataset.url;
          }
        });
      }
    });

    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      if (!inlineMenu.contains(e.target)) {
        closeAllDetails(null);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenu);
  } else {
    initHoverMenu();
  }
})();
